export const TOKKEN = 'Bearer eyJhbGciOiJIUzI1NiIsImtpZCI6IkY3QzdERTM0N0FFNEI5OEUyNDQ4NjMyQjk4Qzc0NjQ0M0Y2OUFDMjBEODc0MDU1RjVFMTBDQjRFRTI0QjZDMUQiLCJ0eXAiOiJKV1QifQ.eyJzdWIiOiI4NUQ2NUNENzY2ODMxMzM0RjY0QzZCQTQ0OUNDM0I4OTc2NDkxREI2QjIzRDZENzgwNDQ2RUU5QzBCMTIxNzc4IiwianRpIjoiZUhuVVdWYUY5dy9VdlJWaTc3NGw1eHIzMlZqTmVBSG95aUpiWmduTEdVbmF1MmJxRTE1L1JjSHh1MmlxVThUUjFtMExLNCt1YTB3a0hSZHcyalc1MUEiLCJ1c2VyVHlwZSI6InVzZXIiLCJpc0luZGl2aWR1YWwiOiJUcnVlIiwidXNlclB1YmxpY0lkIjoiM2NiYzg0OTgtODE0Yy00M2QxLWJhMDItZWUyN2IwMTdmNjhjIiwidXNlcm5hbWUiOiJyYXNobWkucmFqcHV0MSIsImVpZGEiOiIiLCJuYmYiOjE3MzgwNjY5MDQsImV4cCI6MTczODE1MzMwNCwiaWF0IjoxNzM4MDY2OTA0LCJpc3MiOiJFOUU2ODg4Q0YzMUZGM0QwQTRGOEM0ODYyOEVDMjg4OTA5MzY0ODIwM0E0N0I1RDZEQTBGMTNFQjAyQjdFNjUwIiwiYXVkIjoiMzRDMEExRjUxNTk2N0UzRjE3NzQ5MDhCN0U4QzU0MzY5Mjk2QTFDQThGNUZDNjRFNDA3RkM4RTJEMDk0NUI5QSJ9.15M_oPVnfMCLQMIG0Y_qj_n6P84ogrWGykA39a1S_3g';
export const TOKKEN2 = 'Bearer eyJhbGciOiJIUzI1NiIsImtpZCI6IkY3QzdERTM0N0FFNEI5OEUyNDQ4NjMyQjk4Qzc0NjQ0M0Y2OUFDMjBEODc0MDU1RjVFMTBDQjRFRTI0QjZDMUQiLCJ0eXAiOiJKV1QifQ.eyJzdWIiOiI4NUQ2NUNENzY2ODMxMzM0RjY0QzZCQTQ0OUNDM0I4OTc2NDkxREI2QjIzRDZENzgwNDQ2RUU5QzBCMTIxNzc4IiwianRpIjoiZUhuVVdWYUY5dy9VdlJWaTc3NGw1eHIzMlZqTmVBSG95aUpiWmduTEdVbmF1MmJxRTE1L1JjSHh1MmlxVThUUjFtMExLNCt1YTB3a0hSZHcyalc1MUEiLCJ1c2VyVHlwZSI6InVzZXIiLCJpc0luZGl2aWR1YWwiOiJUcnVlIiwidXNlclB1YmxpY0lkIjoiM2NiYzg0OTgtODE0Yy00M2QxLWJhMDItZWUyN2IwMTdmNjhjIiwidXNlcm5hbWUiOiJyYXNobWkucmFqcHV0MSIsImVpZGEiOiIiLCJuYmYiOjE3Mzc4MTUzMDAsImV4cCI6MTczNzkwMTcwMCwiaWF0IjoxNzM3ODE1MzAwLCJpc3MiOiJFOUU2ODg4Q0YzMUZGM0QwQTRGOEM0ODYyOEVDMjg4OTA5MzY0ODIwM0E0N0I1RDZEQTBGMTNFQjAyQjdFNjUwIiwiYXVkIjoiMzRDMEExRjUxNTk2N0UzRjE3NzQ5MDhCN0U4QzU0MzY5Mjk2QTFDQThGNUZDNjRFNDA3RkM4RTJEMDk0NUI5QSJ9.m2raZNn4H460jkk8Y2Nc17fjib0k_Q6lXueByoLUTto';
const applicantDetailsFieldsName = ['firstNameEN', 'firstNameAR', 'middleNameEN', 'middleNameAR', 'lastNameEN', 'lastNameAR', 'motherNameEN', 'motherNameAR', 'currentNationalityId', 'previousNationalityId',
//
'birthDate', 'birthCountryId',
//
'birthPlaceEN', 'birthPlaceAR', 'religionId', 'FaithId', 'genderId', 'educationId', 'professionId', 'languageId', 'maritalStatusId'];
const visitDetailsFieldsName = ['arrivalCountryId', 'bankStatementCountryId', 'visitReason',
// check
'visitDuration',
// check
'entryType' // check
];
// const visitDetailsFieldsName = [
// 'arrivalCountryId', value: 'arrivalCountryId' },
// 'bankStatementCountryId', value: 'bankStatementCountryId' },
// 'visitReason', value: 'visitReason' }, // check
// 'visitDuration', value: 'visitDuration' }, // check
// 'entryType', value: 'entryType' }, // check
// ];

// addressOutsideUAE-> addressOutside2 is required ,
// visitDetails-> visitReason is required,
//  visitDetails-> visitDuration is required
//  visitDetails-> entryType is required
const passportDetailsFieldsName = ['passportNo', 'passportTypeId', 'passportIssueDate', 'passportExpiryDate', 'passportPlaceEN', 'passportPlaceAR', 'passportIssueCountryId', 'passportIssueGovId'];
const addressInsideUAEFieldsName = ['isInsideUAE', 'emirateId', 'cityId', 'areaId', 'street', 'building', 'landmark', 'makaniNo'];
const addressOutsideUAEFieldsName = ['addressOutsideCountryId', 'addressOutsideCity', 'addressOutside1', 'addressOutside2',
// check
'addressOutsideTelNo'];
const contactInfoFieldsName = ['email', 'mobileNo', 'preferredSmsLanguage'];
export const searchPasportFieldMapping = {
  issueDate: 'passportIssueDate',
  prsNationality: 'currentNationalityId',
  expiryDate: 'passportExpiryDate',
  issueCountry: 'passportIssueCountryId',
  issueCountryGovId: 'passportIssueGovId',
  issuePlaceAr: 'passportPlaceAR',
  issuePlaceEn: 'passportPlaceEN',
  passportNo: 'passportNo',
  passportTypeId: 'passportTypeId',
  email: 'email',
  mobileNo: 'mobileNo',
  BirthDate: 'birthDate',
  birthPlaceAr: 'birthPlaceAR',
  birthPlaceEn: 'birthPlaceEN',
  firstNameAr: 'firstNameAR',
  firstNameEn: 'firstNameEN',
  genderId: 'genderId',
  lastNameAr: 'lastNameAR',
  lastNameEn: 'lastNameEN',
  secondNameAr: 'middleNameAR',
  secondNameEn: 'middleNameEN'
};
export const allFieldsList = [...applicantDetailsFieldsName, ...visitDetailsFieldsName, ...passportDetailsFieldsName, ...addressInsideUAEFieldsName, ...addressOutsideUAEFieldsName, ...contactInfoFieldsName];
export const dataMapping = {
  applicantDetails: applicantDetailsFieldsName,
  visitDetails: visitDetailsFieldsName,
  passportDetails: passportDetailsFieldsName,
  addressInsideUAE: addressInsideUAEFieldsName,
  addressOutsideUAE: addressOutsideUAEFieldsName,
  contactInfo: contactInfoFieldsName
};